import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const getServerSnapshot = () => 'UTC';
const getSnapshot = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

/** Render static timestamps in UTC until hydration, then retain device time. */
export function useHydratedTimeZone(): string {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
